<template>
  <div >
    <job-header-simple header_title="申请注销"></job-header-simple>
    <div class="view-page">
      <img src="./assets/icon_success.png">
      <p class="text-p1">是否确认注销？</p>
      <p class="text-p2">个体户注销后，个体户与平台合作关系将被终止，无法收取服务费用，数据将被清除，无法恢复，请谨慎操作！</p>
      <van-button color="#7a84fb" size="small" @click="toLogout" plain>确认注销</van-button>
      <van-button color="#7a84fb" size="small" @click="toList">不注销了</van-button>
    </div>
  </div>
</template>

<script>
import {
  button
} from "vant";
import jobHeaderSimple from "@/components/header/header.vue";
import wx from 'weixin-js-sdk'
import { browserUA } from "@/utils/browserUA";
import {getToken} from "@/utils/auth";

export default {
  components: {
    [button.name]: button,
    jobHeaderSimple
  },
  data() {
    return {
      individualId:this.$route.query.individualId,
    }
  },
  methods: {
    toLogout() {
      // 判断是否小程序
      browserUA().then((browserType) => {
        if (browserType == "MINI") { // 小程序，跳转到小程序拍摄页面
          wx.miniProgram.navigateTo({url: '/pages/individualLogoutVideo/index?individualId='+this.individualId+'&token='+getToken()});
        }else{
          this.$router.push({
            path: '/individual_logout_video',
            query: {
                individualId:this.individualId
            }
          });
        }
      });
    },
    toList() {
      this.$router.push({
        path: "/individual_list",
      });
    }
  },
};
</script>

<style lang="less" scoped>
.view-page{
  text-align: center;
  background: #ffffff;
  margin: 20px 10px;
  padding: 30px 0;
  border-radius: 10px;
  img {
    width: 40px;
    height: 40px;
  }
  .text-p1 {
    font-size: 16px;
  }
  .text-p2 {
    padding-top: 10px;
    font-size: 14px;
    margin: 0 40px;
    padding-bottom: 12px;
    line-height: 24px;
    color: #999;
  }
  .van-button{
    margin: 0 6px;
    width: 126px;
  }
}

</style>


